import { useTranslations } from '@vocab/react';
import { Stack, Text, Inline } from 'braid-design-system';
import type React from 'react';

import { TextLink } from 'src/components';
import { TRACKING_CODES } from 'src/shared/constant';

import translations from '../../.vocab';

const OfficeInfo = ({
  location,
  whatsapp,
}: {
  location: Record<string, string>;
  whatsapp?: string;
}) => {
  const { t } = useTranslations(translations);
  const {
    name,
    address,
    city,
    state,
    post_code,
    operating_hours,
    customer_service_tel,
    sales_tel,
  } = location;

  const showCustomerServiceAndSale = () =>
    ['Kuala Lumpur', 'Hong Kong', 'Bangkok', 'กรุงเทพมหานคร'].some(
      (x) => x === location.name,
    );

  return (
    <Stack space="small">
      <Text weight="strong">{name}</Text>
      {address ? <Text>{address}</Text> : null}
      {Boolean(city || state || post_code) && (
        <Inline space="xsmall">
          {Boolean(city) && <Text>{city}</Text>}
          {Boolean(state) && <Text>{state}</Text>}
          {Boolean(post_code) && <Text>{post_code}</Text>}
        </Inline>
      )}
      {Boolean(customer_service_tel) && showCustomerServiceAndSale() && (
        <Text>
          {t('Customer Service and Sales')}:{' '}
          <PhoneNumber
            linkName={TRACKING_CODES.customer_service_phone_number_clicked}
          >
            {customer_service_tel}
          </PhoneNumber>
        </Text>
      )}
      {Boolean(sales_tel) && name === 'Singapore' && (
        <Text>
          {t('Sales')}:{' '}
          <PhoneNumber linkName={TRACKING_CODES.sales_phone_number_clicked}>
            {sales_tel}
          </PhoneNumber>
        </Text>
      )}
      {Boolean(whatsapp) && (
        <Text>
          {t('WhatsApp')}:{' '}
          <TextLink
            href={`https://wa.me/${whatsapp}`}
            tracking={TRACKING_CODES.customer_service_phone_number_clicked}
          >
            {whatsapp}
          </TextLink>
        </Text>
      )}
      <Text>{operating_hours}</Text>
    </Stack>
  );
};

const PhoneNumber = ({
  children,
  linkName,
}: {
  children: React.ReactNode;
  linkName: string;
}) => (
  <TextLink href={`tel:${children}`} tracking={linkName} skipResolvedUrl>
    {children}
  </TextLink>
);

export default OfficeInfo;
